import { createApp } from 'vue';
import formCreate from '@form-create/element-ui';
import { patchFormCreateFrame } from '@/libs/patch-form-create-frame';
import Cookies from 'js-cookie';

import ElementPlus from 'element-plus';
import 'element-plus/es/components/message/style/css';
import 'element-plus/es/components/message-box/style/css';
import 'element-plus/es/components/notification/style/css';
import 'element-plus/es/components/loading/style/css';
import 'element-plus/es/components/table/style/css';
import 'element-plus/es/components/input/style/css';
import 'element-plus/es/components/input-number/style/css';
import 'element-plus/es/components/select/style/css';

//crmeb_merchant
import '@/styles/index.scss';
// DIY 左侧组件图标（#iconzujian-*）依赖 iconfont.js 注入 SVG symbol，对齐 EB main.js
import '@/styles/iconfont/iconfont.css';
import '@/styles/iconfont/iconfont.js';
import '@/styles/element-plus-override.scss';
import { modalSure,modalSureDelete } from "@/libs/public";
import modalForm from "@/utils/modalForm";
import uploadFrom from '@/components/uploadPictures/uploadFrom';

import App from './App.vue';
import store from './store';
import router from './router';
import directive from './directive'; // directive

import moment from 'moment'
moment.locale('zh-cn')// 使用中文时间

// 注册指令
import plugins from './plugins'; // plugins
import { download } from '@/api/request';
// svg图标
import 'virtual:svg-icons-register';
import SvgIcon from '@/components/SvgIcon/index.vue';
import elementIcons from '@/components/SvgIcon/svgicon';

import { getToken } from '@/utils/auth';
import { startNotice } from '@/libs/notice';

const token = getToken();
if (token) {
  startNotice(token);
}

import './permission'; // permission control


import VueViewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

// Swiper
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'

import {HandlePrice} from "@/utils/util";
import crmebAuth from '@/plugins/crmebAuth';
import baseComponents from '@/components/base/index';

// 数据大屏（对齐 EB main.js：DataV + 全局组件 + 样式）
import DataVVue3 from '@kjgl77/datav-vue3';
import '@kjgl77/datav-vue3/dist/style.css';
import { Vue3SeamlessScroll } from 'vue3-seamless-scroll';
import '@/views/dataScreen/assets/css/index.scss';
import '@/views/dataScreen/assets/css/public.scss';
import Echart from '@/views/dataScreen/components/echart/index.vue';
import ItemWrap from '@/views/dataScreen/components/item-wrap/item-wrap.vue';
import Reacquire from '@/views/dataScreen/components/reacquire/reacquire.vue';
import { ElMessage } from 'element-plus';

/* 表头覆盖必须最后加载（晚于 ele 按需 table 样式） */
import '@/styles/table-header-override.scss';

const app = createApp(App);

// 全局方法挂载
app.config.globalProperties.download = download;

app.config.globalProperties.$modalSure = modalSure;
app.config.globalProperties.$modalForm = modalForm ;

app.config.globalProperties.$deleteSure = modalSureDelete;
app.config.globalProperties.$HandlePrice = HandlePrice;
app.config.globalProperties.$crmebAuth = crmebAuth;
/** 数据大屏等 Options API 页仍用 this.$message */
app.config.globalProperties.$message = ElMessage;

// Swiper 组件
app.component('Swiper', Swiper);
app.component('SwiperSlide', SwiperSlide);

app.use(VueViewer, {
    defaultOptions: {
        zIndex: 9999
    }
})
app.use(ElementPlus, { size: 'default', zIndex: 3000 })
app.use(DataVVue3);
app.use(router);
app.use(store);
app.use(plugins);
app.use(elementIcons);
app.use(formCreate);
// fc-frame 选用户/选图：about:blank 阶段写入的 helper 会在页面加载后丢失
patchFormCreateFrame();
app.use(uploadFrom);
app.use(baseComponents);
app.component('svg-icon', SvgIcon);
app.component('Vue3SeamlessScroll', Vue3SeamlessScroll);
app.component('Echart', Echart);
app.component('ItemWrap', ItemWrap);
app.component('Reacquire', Reacquire);

directive(app);

app.mount('#app');
